<script setup>
import PortalShell from '@/Layouts/PortalShell.vue'
</script>

<template>
  <PortalShell portal="vendor">
    <slot />
  </PortalShell>
</template>
